import React, { useState } from "react";
import { useField } from "formik";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";

const FormikInput = ({ label, type, ...props }) => {
  const [field, meta] = useField(props);
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
  const hasError = meta.touched && meta.error;
  const inputType = showPassword ? "text" : type || "text"; // If showPassword is true, show password, else use the input type

  return (
    <div className={`formik-field-container ${hasError ? "invalid" : ""}`}>
      {label && <label htmlFor={props.id || props.name}>{label}</label>}
      <div className="input-container">
        <input {...field} {...props} type={inputType} />
        {type === "password" && (
          <div className="password-toggle" onClick={() => setShowPassword(!showPassword)}>
            {showPassword ? <VisibilityIcon color="inherit" /> : <VisibilityOffIcon color="inherit" />}
          </div>
        )}
      </div>
      <div className={`feedback ${hasError ? "error" : ""}`}>{hasError ? meta.error : "looks good"}</div>
    </div>
  );
};

export default FormikInput;
